import { MagicLinkForm } from '@/components/auth/magic-link-form';

export default function MagicLinkRequestPage() {
  return (
    <div className="container flex h-screen w-screen flex-col items-center justify-center px-4 m-auto">
      <div className="mx-auto flex w-full max-w-[350px] flex-col justify-center space-y-6">
        <MagicLinkForm />
      </div>
    </div>
  )
}
